import { render, staticRenderFns } from "./NivelDificuldade.vue?vue&type=template&id=59880c3c&scoped=true"
import script from "./NivelDificuldade.vue?vue&type=script&lang=js"
export * from "./NivelDificuldade.vue?vue&type=script&lang=js"
import style0 from "./NivelDificuldade.vue?vue&type=style&index=0&id=59880c3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59880c3c",
  null
  
)

export default component.exports